var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.insertedContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }